import { CLIENT_URL } from '@shared/config/api/api';
import { NO_ACCESS_TOKEN } from '@shared/constants/text';
import { HttpCodes, HttpStatuses } from '@shared/types/enums/http.enum';
import { refreshAccessToken } from '@widgets/Auth/api/refreshAccessToken/refreshAccessToken';

export type FetchDataResponse<T> = {
  data: T | undefined;
  code: HttpCodes;
  status: HttpStatuses;
  message: string;
};

class FetchData {
  private static async req<T>(url: string, options: RequestInit = {}): Promise<FetchDataResponse<T>> {
    const headers = new Headers(options.headers);

    headers.set('Content-Type', 'application/json;charset=utf-8');

    const stringUrl = `${CLIENT_URL}/${url}`;

    let response = await fetch(`${stringUrl}`, { ...options, headers });

    // если не авторизованы, то делаем запрос на обновление access токена,
    // если ответ успешный, то повторяем предыдущий запрос, если нет возвращаем ошибку, что не авторизованы
    if (response.status === HttpCodes.UNAUTHORIZED) {
      const { ok } = await refreshAccessToken();

      if (!ok) {
        return {
          data: undefined,
          code: HttpCodes.UNAUTHORIZED,
          message: NO_ACCESS_TOKEN,
          status: HttpStatuses.ERROR
        };
      }

      response = await fetch(`${stringUrl}`, { ...options, headers });
    }

    return {
      data: await response.json(),
      code: response.status,
      message: '',
      status: HttpStatuses.SUCCESS
    };
  }

  public static async post<T>(url: string, options: RequestInit = {}): Promise<FetchDataResponse<T>> {
    return this.req(url, { ...options, method: 'POST' });
  }

  public static async get<T>(url: string, options: RequestInit = {}): Promise<FetchDataResponse<T>> {
    return this.req(url, { ...options, method: 'GET' });
  }

  public static async delete<T>(url: string, options: RequestInit = {}): Promise<FetchDataResponse<T>> {
    return this.req(url, { ...options, method: 'DELETE' });
  }

  public static async patch<T>(url: string, options: RequestInit = {}): Promise<FetchDataResponse<T>> {
    return this.req(url, { ...options, method: 'PATCH' });
  }
}

export default FetchData;
